import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { Text, Flex, Link } from "@chakra-ui/react"
import Hero from "../components/hero"

import Layout from "../components/layout"

const styles = {
  hero: {
    root: {
      pt: "40px",
      pb: "20px",
    },
    "left-box": {
      width: "100%",
      alignItems: { base: "center", md: "center", lg: "center" },
    },
    heading: {
      textAlign: "center",
    },
    icon: {
      mt: "0px",
    },
  },
  "text-box": {
    flexDirection: "column",
    width: "100%",
    px: "24px",
    pb: "70px",
  },
  text: {
    mt: "24px",
    textAlign: "left",
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "0.0015em",
    color: "#1B263F",
  },
}

class PrivacyPolicy extends React.Component {
  render() {
    return (
      <Layout location={this.props.location} title={"Privacy Policy"}>
        <Hero title="Privacy Policy" styles={styles.hero} />
        <Flex sx={styles["text-box"]}>
          <Text sx={styles.text} fontWeight="bold">
            Avant-garde Health Website Privacy Policy
          </Text>

          <Text sx={styles.text}>
            We respect your privacy and are committed to protecting it through
            our compliance with this privacy policy (“Policy”). This Policy
            describes the types of information we may collect from you or that
            you may provide (“Personal Information”) on the avantgardehealth.com
            website (“Website” or “Service”) and any of its related products and
            services (collectively, “Services”), and our practices for
            collecting, using, maintaining, protecting, and disclosing that
            Personal Information. It also describes the choices available to you
            regarding our use of your Personal Information and how you can
            access and update it.
          </Text>

          <Text sx={styles.text}>
            This Policy is a legally binding agreement between you (“User”,
            “you” or “your”) and Avant-garde Health (“Avant-garde Health”, “we”,
            “us” or “our”). If you are entering into this agreement on behalf of
            a business or other legal entity, you represent that you have the
            authority to bind such entity to this agreement, in which case the
            terms “User”, “you” or “your” shall refer to such entity. If you do
            not have such authority, or if you do not agree with the terms of
            this agreement, you may not access and use the Website and Services.
          </Text>

          <Text sx={styles.text}>
            By accessing and using the Website and Services, you acknowledge
            that you have read, understood, and agree to be bound by the terms
            of this Policy. This Policy does not apply to the practices of
            companies that we do not own or control, or to individuals that we
            do not employ or manage.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Automatic collection of information
          </Text>

          <Text sx={styles.text}>
            When you open the Website, our servers automatically record
            information that your browser sends. This data may include
            information such as your device’s IP address, browser type and
            version, operating system type and version, language preferences,
            pages of the Website that you visit, the time spent on those pages,
            information you search for, access times and dates, and other
            statistics.
          </Text>

          <Text sx={styles.text}>
            Information collected automatically is used only to identify
            potential cases of abuse and establish statistical information
            regarding usage and traffic. This information is not otherwise
            aggregated in such a way that would identify any particular User.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Collection of personal information
          </Text>

          <Text sx={styles.text}>
            You can access and use the Website and Services without telling us
            who you are or revealing any information by which someone could
            identify you as a specific individual. If, however, you wish to use
            some of the features offered on the Website, you may be asked to
            provide certain Personal Information (for example, your name and
            email address).
          </Text>

          <Text sx={styles.text}>
            We receive and store any information you knowingly provide to us
            when you fill out forms on the Website. This may include:
          </Text>

          <Text sx={styles.text}>
            - Contact information (email address, phone number, etc.)
          </Text>
          <Text sx={styles.text}>
            - Basic personal information (name, country of residence, etc.)
          </Text>

          <Text sx={styles.text}>
            You can choose not to provide Personal Information, but certain
            features may not be available.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Privacy of children
          </Text>

          <Text sx={styles.text}>
            We do not knowingly collect Personal Information from children under
            18. If you believe that a child under 18 has provided Personal
            Information, please contact us to request deletion.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Use and processing of collected information
          </Text>

          <Text sx={styles.text}>
            We may collect and use Personal Information as necessary to:
          </Text>

          <Text sx={styles.text}>
            - Provide and improve products and services
          </Text>
          <Text sx={styles.text}>
            - Send marketing communications and product updates
          </Text>

          <Text sx={styles.text}>- Respond to inquiries and offer support</Text>

          <Text sx={styles.text}>- Improve user experience and security</Text>

          <Text sx={styles.text}>
            - Enforce terms and comply with legal requirements
          </Text>

          <Text sx={styles.text}>- Prevent abuse and malicious activity</Text>

          <Text sx={styles.text}>
            We may act as a data controller or processor depending on context.
            In certain cases, your Personal Information may be processed based
            on your consent, legal obligations, contractual necessity, or our
            legitimate interests.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Disclosure of information
          </Text>

          <Text sx={styles.text}>
            We may share your information with trusted Service Providers who
            help operate our Website and Services, but only as necessary to
            perform contracted services. We may also disclose Personal
            Information if legally required or necessary to protect our rights
            or comply with legal obligations.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Retention of information
          </Text>

          <Text sx={styles.text}>
            We retain Personal Information as long as necessary to fulfill the
            purposes outlined in this Policy and as required by law. Aggregated
            or anonymized data may be retained longer.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            California privacy rights
          </Text>

          <Text sx={styles.text}>
            California residents may have additional rights under the California
            Consumer Privacy Act (CCPA), including the right to access, delete,
            or opt out of certain uses of Personal Information. Requests can be
            submitted through the contact details below.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            How to exercise your rights
          </Text>

          <Text sx={styles.text}>
            Requests to exercise your privacy rights may require identity
            verification. We will respond to requests in accordance with
            applicable laws.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Cookies
          </Text>

          <Text sx={styles.text}>
            Our Website and Services use cookies to personalize your online
            experience and support essential functionality. A cookie is a text
            file placed on your device by a web server. Cookies cannot be used
            to run programs or deliver viruses.
          </Text>

          <Text sx={styles.text}>We use cookies for:</Text>

          <Text sx={styles.text}>- Site functionality and security</Text>

          <Text sx={styles.text}>
            - Aggregated analytics and usage tracking
          </Text>

          <Text sx={styles.text}>- Customer support and chat features</Text>

          <Text sx={styles.text}>
            Third-party services that may use cookies include:
          </Text>

          <Text sx={styles.text}>
            - <b>Drift</b> (customer chat and support)
          </Text>

          <Text sx={styles.text}>
            - <b>Vimeo</b> (embedded video playback)
          </Text>

          <Text sx={styles.text}>
            - <b>Amplitude</b> (product analytics)
          </Text>

          <Text sx={styles.text}>
            - <b>Sentry</b> (application monitoring and error tracking)
          </Text>

          <Text sx={styles.text}>
            These third-party services may collect limited technical information
            related to your interaction with our Website. We do not sell or
            share Personal Information collected through cookies for cross-site
            advertising or behavioral targeting.
          </Text>

          <Text sx={styles.text}>
            We primarily operate in the United States and do not target users in
            jurisdictions that require cookie consent banners (e.g., European
            Union or United Kingdom). Users may manage cookie preferences via
            browser settings. Declining cookies may impact certain
            functionality.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Data analytics
          </Text>

          <Text sx={styles.text}>
            We use third-party analytics and monitoring tools, including
            Amplitude and Sentry, to collect information on Website usage and
            performance. This data is collected on an aggregated and
            non-personally identifiable basis to help improve and secure our
            Website and Services. Analytics data is not used for advertising
            purposes.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Do Not Track signals
          </Text>

          <Text sx={styles.text}>
            The Website does not track visitors across third-party websites and
            does not respond to Do Not Track (DNT) signals. Third-party
            providers may track your browsing activity according to their own
            policies.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Advertisements
          </Text>

          <Text sx={styles.text}>
            We may work with third-party providers to display advertising
            related to our services. These third parties may collect limited
            data through cookies or other technologies as described above.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Social media features
          </Text>

          <Text sx={styles.text}>
            Our Website may include social media features (e.g., Facebook,
            LinkedIn, or Twitter buttons) that may collect information such as
            IP address and page visits. Your interactions with these features
            are governed by the respective providers' privacy policies.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Email marketing
          </Text>

          <Text sx={styles.text}>
            We may offer newsletters or marketing emails which you can
            unsubscribe from at any time. We do not disclose email addresses to
            third parties except as necessary to provide email services.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Links to other resources
          </Text>

          <Text sx={styles.text}>
            Our Website may link to third-party websites and services that we do
            not control. We encourage you to review their privacy policies.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Information security
          </Text>

          <Text sx={styles.text}>
            We maintain administrative, technical, and physical safeguards to
            protect Personal Information. However, no method of transmission
            over the Internet or storage is 100% secure.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Data breach
          </Text>

          <Text sx={styles.text}>
            If we become aware of a data breach that affects your Personal
            Information, we will notify you and take appropriate remedial action
            in accordance with applicable law.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Changes and amendments
          </Text>

          <Text sx={styles.text}>
            We reserve the right to modify this Policy. Updates will be posted
            on this page, with the date of the last revision indicated below.
          </Text>

          <Text sx={styles.text}>Acceptance of this policy</Text>

          <Text sx={styles.text}>
            By accessing and using the Website, you agree to this Policy.
          </Text>

          <Text sx={styles.text} fontWeight="bold">
            Contacting us
          </Text>

          <Text sx={styles.text}>
            If you have questions about this Policy or wish to exercise your
            rights, please contact us at:{" "}
            <Link as={GatsbyLink} sx={styles.text} to="/contact-us/">
              https://www.avantgardehealth.com/contact-us
            </Link>
          </Text>

          <Text sx={styles.text}>
            This document was last updated on June 2, 2025
          </Text>
        </Flex>
      </Layout>
    )
  }
}

export default PrivacyPolicy
